import {
  DailyPvUpdateParametersRequest,
  Device,
  ScoutDivisionCode,
  ApplicationRouteCode,
} from '@doda/api-client/aspida/@types';
import { QueryParams } from '../../constants/queryParams';

/**
 * 日別PVカウントアップ用のパラメータオブジェクトを作成します。
 *
 * @param {QueryParams} queryParams - クエリパラメータのオブジェクト。
 * @param {boolean} loginStatus - ユーザーのログイン状態。
 * @param {string} wmuid - 原稿ID
 * @param { PC | SP } device - 画面
 * @returns {DailyPvUpdateParametersRequest} APIリクエスト用に構築されたパラメータオブジェクト。
 */
export const createPvCountUpParam = ({
  queryParams,
  loginStatus,
  wmuid,
  device,
}: {
  queryParams: QueryParams;
  loginStatus: boolean;
  wmuid: string;
  device: Device;
}) => {
  const param = {
    bnId: queryParams.bnid ?? '',
    bnnt: queryParams.bnnt ?? '',
    cid: queryParams.cid ?? '',
    fid: queryParams.fid ?? '',
    fm: queryParams.fm ?? '',
    inp: queryParams.inp ?? '',
    scoutlist_id: queryParams.scoutlist_id ?? '',
    message_id: queryParams.message_id ?? '',
    osscfl: queryParams.osscfl ?? '',
    wlstid: queryParams.wlstid ?? '',
  };

  // scoutlist_idが999999999でないかつ未ログインの場合は値を削除する
  if (param.scoutlist_id !== '999999999' && !loginStatus) {
    param.scoutlist_id = '';
  }

  const data: DailyPvUpdateParametersRequest = {
    wmuid: wmuid ?? '',
    device,
    scoutDivisionCode: (queryParams.osscfl as ScoutDivisionCode) ?? undefined,
    scoutId: queryParams.scoutlist_id ?? undefined,
    bannerId: queryParams.bnid ?? undefined,
    applicationRouteCode: getApplicationRouteCode(param),
    topicId: queryParams.fid ?? undefined,
  };

  return data;
};

/**
 * URLパラメータから応募経路コード(applicationRouteCode)を取得します。
 * @param param
 * @param {string} [fid] - 特集枠ID
 * @param {string} [fm] - 経路
 * @param {string} [cid] - メールマガジン
 * @returns {ApplicationRouteCode | undefined} 応募経路コードを返します。対応するパラメータがない場合はundefinedを返します。
 */
const getApplicationRouteCode = (param: {
  fid?: string;
  fm?: string;
  cid?: string;
}): ApplicationRouteCode | undefined => {
  let routeCode: ApplicationRouteCode | undefined;

  if (param.fid) {
    routeCode = '1';
  } else if (param.fm === 'nlbn') {
    routeCode = '2';
  } else if (param.cid === 'mail') {
    routeCode = '3';
  } else if (param.fm === 'list') {
    routeCode = '4';
  }
  return routeCode;
};
